// extracted by mini-css-extract-plugin
module.exports = {"desc":"_3leJh","descBottom":"_14Gsj","footer":"_3qUHu","footer2":"_1axgW"};